import type { IMatrixLayout } from './IMatrixLayout';

const K = 'recordPage.viz.swot.';

/**
 * Матриця SWOT аналізу (прототип v4): «Походження ↓ · Вплив →»; колонки «Сприятливі · Несприятливі»; «Внутрішні» — сильні й слабкі
 * сторони, «Зовнішні» — можливості й загрози; сприятливе — зелене, несприятливе — червонувате; без архівних елементів.
 */
export const SWOT_LAYOUT: IMatrixLayout = {
  field: 'sw', rowsAxis: `${K}origin`, colsAxis: `${K}effect`, cols: [`${K}helpful`, `${K}harmful`], summary: `${K}summary`, skipArchived: true,
  keys: [{ label: `${K}helpful`, tone: 'good' }, { label: `${K}harmful`, tone: 'bad' }],
  rows: [
    { key: 'internal', label: `${K}internal`, cells: [{ value: 'Strong point', tone: 'good', note: `${K}strengths` }, { value: 'Weak point', tone: 'bad', note: `${K}weaknesses` }] },
    { key: 'external', label: `${K}external`, cells: [{ value: 'Opportunity', tone: 'good', note: `${K}opportunities` }, { value: 'Threat', tone: 'bad', note: `${K}threats` }] },
  ],
};
